// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3vJ62","ranges":"BmiRanges_ranges__39av7"};